import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const user = await loginWithGoogle(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${user.name}!`);
        const pendingSeller = localStorage.getItem("xurray_pending_role") === "seller";
        if (pendingSeller) localStorage.removeItem("xurray_pending_role");
        let dest = user.role === "admin" ? "/admin" : user.role === "seller" ? "/seller" : "/";
        // A Google user who came in to start selling goes to the Seller Center onboarding (unless already an approved seller/admin).
        if (pendingSeller && user.role !== "admin" && !(user.role === "seller" && user.seller_status === "approved")) dest = "/sell";
        navigate(dest, { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}
